/**
 * Whitelist utility for the Palm Heist Auction
 * This file manages access control to the auction page
 */

// Currently whitelisted addresses
// In production, this would be loaded from a database or external file
const WHITELISTED_ADDRESSES = [
  "HUHv2JKDXvKzr2GMepCUcw6E9B6Hg4LGcMLT4SEY6dCs", // Owner's address
  "2KW2XRd9kwqet15Aha2oK3tYvd3nWbTFH1MBiRAv1BE1", // Test address 1
  "BvzKvn6nUUAYNx4HfNd3S9JZJTJro8CkzXtwj8gounTW", // Test address 2
  "5ZWj7a1f8tWkjBESHKgrLmXshuXxqeY9SYcfbshpAqPG", // Test address 3
];

/**
 * Check if an address is whitelisted
 * @param {string} address - The wallet address to check
 * @returns {boolean} - True if the address is whitelisted or has password bypass
 */
export const isWhitelisted = (address) => {
  // Check if user has password bypass
  if (localStorage.getItem('palmheist_password_bypass') === 'true') {
    return true;
  }
  
  // Check if address is in whitelist
  if (!address) return false;
  return WHITELISTED_ADDRESSES.includes(address);
};

/**
 * For large whitelists (50k+ addresses), we would use a more efficient approach:
 * 1. Store addresses in a Set for O(1) lookup
 * 2. Potentially use a Bloom filter for very large lists
 * 3. Load addresses in chunks or on-demand from an external source
 */

// Example implementation for large whitelist
let whitelistSet = null;

/**
 * Initialize the whitelist with a large number of addresses
 * This would be called when the app starts or when needed
 */
export const initializeWhitelist = async () => {
  try {
    // In a real implementation, this would fetch from an API or load from a file
    // For now, we're just using our small hardcoded list
    whitelistSet = new Set(WHITELISTED_ADDRESSES);
    return true;
  } catch (error) {
    console.error("Failed to initialize whitelist:", error);
    return false;
  }
};

/**
 * Check if an address is in the large whitelist
 * Uses Set for O(1) lookup performance
 */
export const isWhitelistedFast = (address) => {
  if (!address) return false;
  
  // Initialize the set if it doesn't exist yet
  if (!whitelistSet) {
    whitelistSet = new Set(WHITELISTED_ADDRESSES);
  }
  
  return whitelistSet.has(address);
};

/**
 * Add an address to the whitelist (admin function)
 */
export const addToWhitelist = (address) => {
  if (!address) return false;
  
  if (!whitelistSet) {
    whitelistSet = new Set(WHITELISTED_ADDRESSES);
  }
  
  whitelistSet.add(address);
  return true;
};

export default {
  isWhitelisted,
  isWhitelistedFast,
  initializeWhitelist,
  addToWhitelist
};
